var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-content',{scopedSlots:_vm._u([{key:"top",fn:function(){return [_c('hero-header',{attrs:{"heading":"Net Asset Statements"}})]},proxy:true}])},[(_vm.loaded)?[_c('asset-statement-filter')]:[_c('base-loader')]],2)}
var staticRenderFns = []

export { render, staticRenderFns }